import React, { useCallback, useState, useEffect, useContext, useMemo } from 'react'
import { observer } from 'mobx-react'
import { classNames } from '@dt/fe-utils'
import { Price, ProductImage, Stepper, Tags } from 'components'
import CashierController from 'controllers/cashierController'
import { cartMobx, productSaleMobx } from 'restaurant'
import MonthSaleInfo from '../MonthSaleInfo'
import './index.scss'

// interface
type TProductItem = 'classic' | 'list';
interface IProps {
  type?: TProductItem;
  product: IViewProduct;
  onClick?: (product: IViewProduct) => void;
  count?: number;
  lazy?: boolean;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  decorate?: TMealCommonDecorates;
}

const ProductItem: React.FC<IProps> = ({ type = 'waterfall', product, count, lazy = false, decorate, imgLoaded = false, onClick }) => {
  let { no, name, price, actualPrice, memberPrice, saleCnt, offPrice, isMemberDiscount, isCanTogo } = product || {}
  const soldout = saleCnt === 0
  // 是否展示加购按钮
  const isShowAddBtn = !!Config.buyTogetherId || !!decorate?.showAddButton
  /** 获得图片的宽高 */
  const [productStyle] = useState(() => {
    if (type === 'classic') {
      return {
        width: 88,
        height: 88
      }
    } else {
      return {
        width: 88,
        height: 88
      }
    }
  })

  const handleChangeCnt = useCallback((isAdd: boolean, event: React.MouseEvent) => {
    event.stopPropagation()
    CashierController.handleProductToCart({
      type: isAdd ? 'add' : 'minus',
      product
    })
  }, [count])

  // 库存数量
  const inventoryCnt = useMemo(() => {
    return productSaleMobx.productNoToScaleCntMap?.[product.no]?.cnt
  }, [productSaleMobx.saleList])

  const [defaultImg, setDefault] = useState<string>('')

  useEffect(() => {
    const imgArr = JSON.parse(product.pics || '[]').filter(item => !!item || !!item.url)
    const defaultItem = imgArr.filter(item => item.default !== 0)
    const defaultImgUrl: string = defaultItem.length ? (defaultItem[0].type === 'video' ? defaultItem[0].videoImageUrl : product.pic) : product.pic
    setDefault(defaultImgUrl)
  }, [product])

  return (
    <div
      className={classNames(
        'product-item list',
        type,
        {
          'sold-out': soldout,
        },
        `${decorate?.imagePosition || 'right'}-list`
      )}
      id={type + 'product' + no}
      onClick={() => onClick ? onClick(product) : CashierController.showProductDetail(product)}
    >
      <div className='product-info'>
        <h3 style={{ fontSize: `${decorate?.fontSetting?.name?.fontSize || 16}px`, fontWeight: decorate?.fontSetting?.name?.fontWeight ? 700 : 500 }}>{name}</h3>
        {
          !!product.intro && <p className='product-intro' dangerouslySetInnerHTML={{ __html: product.intro.replace(/<style[\S\s]*<\/style>/g, '').replace(/<img[^>]*>/g, '') }}></p>
        }
        <Tags datas={[...(product.tags || []), ...(product.allergys || [])]} salesCnt={product.salesCnt} disableTogo={cartMobx.info.eatType !== 'dinein' && !product.isCanTogo} disableSingleSale={!product.isSingleSale} />
        <MonthSaleInfo showHot={decorate?.showHot} showMonthSales={decorate?.showMonthSales} showSalesCnt={decorate?.showSalesCnt} inventoryCnt={inventoryCnt} statSaleCnt={product.statSaleCnt} statAvatar={product.statAvatar} />
        <div className='product-actions'>
          <Price
            decorate={decorate}
            className='product-price'
            price={price}
            actualPrice={actualPrice}
            hideMarketPrice={!!count}
            soldOut={soldout}
            offPrice={offPrice}
            memberPrice={memberPrice}
            isMemberDiscount={isMemberDiscount}
          />
          {!soldout && isShowAddBtn && <Stepper cnt={count} onChange={handleChangeCnt} hideMinus={count === 0} disabled={cartMobx.info.eatType !== 'dinein' && !isCanTogo} />}
          {
            soldout && <span className='sold-out-msg'>{i18n.t('common.soldout')}</span>
          }
        </div>
      </div>
      <div className={classNames('product-other-box', { 'only-cnt-num': !defaultImg && !isShowAddBtn && count })}>
        {
          !!defaultImg && (
            <ProductImage
              imgSrc={(imgLoaded || !lazy) ? defaultImg : ''}
              width={72}
              height={72}
              className='waterfall-img'
            />
          )
        }
        {
          !!count && !isShowAddBtn && <div className='product-cnt'>{count}</div>
        }
      </div>
    </div>
  )
}
export default observer(ProductItem)
